const supportMessage = 'If this is unexpected, please contact support for assistance.';

const buildFundNameList = (funds = []) => funds
  .map((fund) => fund && fund.name)
  .filter((name) => !!name);

export default function createFundConfigurationError(funds = []) {
  if (!funds || funds.length === 0) {
    return null;
  }

  const fundsMissingFundIds = funds.filter((fund) => !fund.fundId);
  if (fundsMissingFundIds.length > 0) {
    const names = buildFundNameList(fundsMissingFundIds);
    if (names.length === 1) {
      return `${names[0]} is not configured correctly (missing fund ID). ${supportMessage}`;
    }
    if (names.length > 1) {
      return `The following funds are missing fund IDs and are not configured correctly: ${names.join(', ')}. ${supportMessage}`;
    }
    return `Some funds are missing fund IDs and are not configured correctly. ${supportMessage}`;
  }

  const fundsMissingNetSuiteIds = funds.filter((fund) => !fund.aFundId && !fund.qFundId);
  if (fundsMissingNetSuiteIds.length === 1) {
    const [name] = buildFundNameList(fundsMissingNetSuiteIds);
    return `${name || 'Fund'} is not configured correctly (missing fund ids). ${supportMessage}`;
  }
  if (fundsMissingNetSuiteIds.length > 1) {
    return `Some funds are not configured correctly. ${supportMessage}`;
  }

  return null;
}
